const { useRef, useState, useEffect } = wp.element;

export function LoadingSpinner(props = {}) {
  const {
    label = 'Loading...',
    isLoading = false
  } = props;

  const [isVisible, setIsVisible] = useState(props.isLoading);

  const nodeRef = useRef(null);

  useEffect(() => {
    setIsVisible(isLoading);
  }, [isLoading, isVisible, setIsVisible])

  return (
      <div ref={nodeRef} className="loading-spinner">
        <h3 className="text-center text-xl">{label}</h3>
      </div>
  )
}